import { CSSProperties, ReactNode, useEffect, useState } from 'react';

const UNMOUNTED = 0;
const EXITED = 1;
const ENTERING = 2;
const ENTERED = 3;
const EXITING = 4;

const transitionStyles: Record<number, CSSProperties> = {
  1: { opacity: 0 },
  2: { opacity: 0 },
  3: { opacity: 1 },
  4: { opacity: 0 },
};

interface IFadeInOutProps {
  show: boolean;
  duration: number;
  className?: string;
  styles?: CSSProperties;
  children?: ReactNode;
}

const FadeInOut = (props: IFadeInOutProps) => {
  const [status, setStatus] = useState<number>(UNMOUNTED);

  useEffect(() => {
    const { show } = props;
    if (show) {
      performEnter();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let nextStatus: number | null = null;
    if (props.show) {
      if (status !== ENTERING && status !== ENTERED) {
        nextStatus = ENTERING;
      }
    } else {
      if (status === ENTERING || status === ENTERED) {
        nextStatus = EXITING;
      }
    }

    updateStatus(nextStatus);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status]);

  const updateStatus = (nextStatus: number | null) => {
    if (nextStatus !== null) {
      if (nextStatus === ENTERING) {
        performEnter();
      } else {
        performExit();
      }
    } else if (status === EXITED) {
      setStatus(UNMOUNTED);
    }
  };

  const performEnter = () => {
    setStatus(ENTERING);
    setTimeout(() => {
      setStatus(ENTERED);
    }, 0);
  };

  const performExit = () => {
    const { duration } = props;
    setStatus(EXITING);
    setTimeout(() => {
      setStatus(EXITED);
    }, duration);
  };

  if (status === UNMOUNTED) {
    return null;
  }

  const { children, duration, className, styles } = props;

  return (
    <div
      className={className}
      style={{
        ...styles,
        transition: `opacity ${duration}ms ease-in-out`,
        opacity: 0.1,
        ...transitionStyles[status],
      }}
    >
      {children}
    </div>
  );
};

export default FadeInOut;
